
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/hooks/useAuth";
import { AIAssistantProvider } from "@/contexts/ai-assistant/AIAssistantContext";
import ErrorBoundary from "@/components/error/ErrorBoundary";
import { initSentry } from "./services/sentryService";
import AppRoutes from "./routes";
import QueryClientProvider from "./providers/QueryClientProvider";
import { ThemeProvider } from "./providers/ThemeProvider";

// Initialize Sentry with your actual DSN
initSentry('https://66b9ac24971cd2b7add1501903bcd56e@o4509060573167616.ingest.de.sentry.io/4509060579852368');

// Function to determine if the current path is a public page
const isPublicPage = () => {
  const publicRoutes = ['/', '/auth', '/contact', '/about', '/terms', '/privacy'];
  return publicRoutes.includes(window.location.pathname);
};

function App() {
  return (
    <ErrorBoundary name="app-root">
      <ThemeProvider defaultTheme="system" storageKey="directpress-ui-theme" publicPage={isPublicPage()}>
        <QueryClientProvider>
          <TooltipProvider>
            <AuthProvider>
              <AIAssistantProvider>
                <AppRoutes />
              </AIAssistantProvider>
            </AuthProvider>
          </TooltipProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
